export const categoryDetails: Record<string, {
  intro: string;
  rules: string[];
  tips: string[];
  features: string[];
  imageSeq: string;
}> = {
  'guobiao-majiang': {
    intro: '国标麻将是国家体育总局于1998年颁布的竞技麻将规则，共包含81个番种，是国际麻将比赛的标准规则。国标麻将讲究牌型的多样性和得分的最大化，既考验运气也考验智慧，是麻将竞技化的典范之作。',
    rules: [
      '使用144张牌（万、条、筒各36张，字牌28张，花牌8张）',
      '四人参与，每人13张手牌',
      '采用轮庄制，庄家胡牌可连庄',
      '81种番种按分值分为1分至88分共12级',
      '胡牌须至少达到8分起和线',
      '允许吃、碰、杠等基本操作',
    ],
    tips: [
      '优先考虑高分番种组合，如清一色(24分)+平和(2分)',
      '注意门清状态可额外获得门清番种加分',
      '开局尽早确定牌型方向，避免犹豫不决',
      '合理利用花牌，每张花牌可加1分',
      '观察对手出牌，推测对方牌型并做好防守',
    ],
    features: [
      '规则完整规范，适合竞技比赛',
      '番种体系丰富，策略深度高',
      '全国通用性强，麻友基础广泛',
      '计分规则透明，公平性高',
    ],
    imageSeq: 'cat-detail-guobiao',
  },
  'sichuan-majiang': {
    intro: '四川麻将又称血战到底，是四川地区最具代表性的麻将玩法。四川麻将去除了风牌和字牌，共108张牌，讲究速战速决。最大的特色是"血战到底"——胡牌后不结束，其他玩家继续战斗直到只剩一人未胡牌。',
    rules: [
      '使用108张牌（万、条、筒各36张），无风牌和字牌',
      '必须缺一门才能胡牌',
      '血战到底：有人胡牌后，其余玩家继续游戏',
      '不允许吃牌，只能碰和杠',
      '点杠者全包（刮风下雨规则）',
      '最后查叫，未听牌者需赔付已听牌者',
    ],
    tips: [
      '早定缺门方向，尽快完成缺门',
      '注意杠牌时机，点杠可能被反制',
      '优先做清一色，分值最高',
      '利用血战规则，胡牌后可继续扩大战果',
      '密切关注剩余牌数，计算胡牌概率',
    ],
    features: [
      '节奏明快，刺激性强',
      '血战到底机制独特，趣味性高',
      '简化的牌型降低入门门槛',
      '对抗性强，每局都有翻盘可能',
    ],
    imageSeq: 'cat-detail-sichuan',
  },
  'guangdong-majiang': {
    intro: '广东麻将是粤港澳地区最流行的麻将玩法，玩法灵活多变，包含推倒胡、鸡平胡等多种变体。广东麻将注重策略与技巧的结合，胡牌方式多样，是南方麻将的代表流派。',
    rules: [
      '使用136张牌（万、条、筒各36张，字牌28张）',
      '四人参与，每人13张手牌',
      '允许吃、碰、杠操作',
      '推倒胡：胡牌无起和限制',
      '可抢杠胡和杠上开花',
      '十三幺、大四喜等大牌型可获额外奖励',
    ],
    tips: [
      '灵活运用吃碰杠，加快听牌速度',
      '留意鸡平胡机会，积小胜为大胜',
      '抢杠有风险，需判断对手牌型',
      '大牌型小牌型灵活切换',
      '善于利用字牌组合作将牌',
    ],
    features: [
      '玩法灵活，适应性强',
      '推倒胡降低新手门槛',
      '多种胡牌方式增加变数',
      '在港澳及海外华人圈影响广泛',
    ],
    imageSeq: 'cat-detail-guangdong',
  },
  'xueliu-chenghe': {
    intro: '血流成河是近年兴起的热门麻将玩法，最大特色是胡牌后不下桌，可以继续摸牌、打牌、胡牌，直到牌墙摸完为止。每局可能出现多次胡牌，节奏极快、刺激性极强。',
    rules: [
      '使用108张牌（万、条、筒各36张）',
      '必须缺一门才能胡牌',
      '胡牌后不下桌，继续游戏',
      '每局可多次胡牌，统计总分',
      '允许自摸和点炮',
      '牌墙摸完即结束',
    ],
    tips: [
      '胡牌后不要放松，继续争取更多胡牌',
      '注意牌墙剩余，合理规划后续出牌',
      '优先胡大牌，利用多次胡牌机会扩大优势',
      '观察谁已经胡牌，调整对他人的防守',
      '最后阶段要敢于冒险，孤注一掷',
    ],
    features: [
      '节奏极快，一局可多次体验胡牌快感',
      '不淘汰机制，娱乐性更强',
      '运气与技巧并重',
      '非常受年轻玩家欢迎',
    ],
    imageSeq: 'cat-detail-xueliu',
  },
  'changsha-majiang': {
    intro: '长沙麻将讲究快、准、狠，胡牌方式多样，允许抢杠胡和海底捞月。长沙麻将的规则在湖南地区影响深远，拥有庞大的玩家群体，其独特的计分方式和胡牌规则深受喜爱。',
    rules: [
      '使用108张牌（万、条、筒各36张）',
      '四人参与，每人13张手牌',
      '允许碰和杠，不允许吃',
      '支持抢杠胡和杠上开花',
      '海底捞月额外加分',
      '扎鸟玩法增加变数',
    ],
    tips: [
      '抢杠胡是长沙麻将的经典操作，时机把握至关重要',
      '做杠时要提防被抢杠',
      '海底捞月是翻盘利器，后期注意留听',
      '扎鸟增加随机性，心态要稳',
      '快节奏下保持冷静判断',
    ],
    features: [
      '打法爽快，节奏紧凑',
      '抢杠胡机制增加博弈性',
      '扎鸟让每局都充满悬念',
      '湖南地区群众基础深厚',
    ],
    imageSeq: 'cat-detail-changsha',
  },
  'dongbei-majiang': {
    intro: '东北麻将规则简洁明快，去除花牌简化流程，强调牌型的纯粹与计算的精准。东北麻将在东北三省拥有广泛的群众基础，以其简洁易懂的规则和明快的节奏受到喜爱。',
    rules: [
      '使用136张牌（万、条、筒各36张，字牌28张）',
      '四人参与，每人13张手牌',
      '允许吃、碰、杠操作',
      '无花牌，规则更纯粹',
      '必须成胡，即必须听牌后才能胡',
      '点炮全包制',
    ],
    tips: [
      '必须尽快听牌，不能拖泥带水',
      '合理利用字牌加快听牌',
      '点炮全包所以要谨慎出牌',
      '成胡制度下防守更加重要',
      '计算精准是东北麻将的核心',
    ],
    features: [
      '规则简洁，上手容易',
      '成胡制度增加策略性',
      '黑龙江、吉林、辽宁三省广泛流行',
      '无花牌使牌型更纯粹',
    ],
    imageSeq: 'cat-detail-dongbei',
  },
};

export const categoryFAQs: Record<string, { question: string; answer: string }[]> = {
  'guobiao-majiang': [
    { question: '国标麻将多少分才能胡？', answer: '国标麻将至少需要达到8分（起和线）才能胡牌。这意味着你的牌型中必须包含至少8分的番种组合。新手建议从简单的番种组合练起，如平和(2分)、无字(1分)、断幺(2分)等基础番种。' },
    { question: '国标麻将有多少张牌？', answer: '国标麻将使用144张牌，包括万子牌36张、条子牌36张、筒子牌36张、字牌（东南西北中发白）共28张，以及花牌（春夏秋冬梅兰竹菊）8张。' },
    { question: '国标麻将可以吃牌吗？', answer: '可以。国标麻将允许吃、碰、杠三种基本操作。吃牌只能吃上家的牌，碰和杠没有限制。' },
  ],
  'sichuan-majiang': [
    { question: '四川麻将为什么叫血战到底？', answer: '因为四川麻将采用血战到底规则：当有一家胡牌后，其余三家继续游戏，直到只剩最后一家未胡牌为止。这种机制让每局都充满了翻盘的可能，非常刺激。' },
    { question: '四川麻将必须缺一门吗？', answer: '是的。四川麻将的规则要求必须缺一门才能胡牌。也就是说，你的手牌中最多只能有两种花色的牌（万、条、筒三选二）。' },
    { question: '四川麻将可以吃牌吗？', answer: '不可以。四川麻将只能碰牌和杠牌，不允许吃上家的牌。这加快了游戏节奏，也增加了牌型的不确定性。' },
  ],
};

export const articleDetails: Record<string, {
  content: string[];
  tags: string[];
  relatedArticles: string[];
}> = {
  'majiang-rumen-jiaocheng': {
    tags: ['入门教程', '新手必看', '麻将基础'],
    relatedArticles: ['guobiao-majiang-fanzhong', 'majiang-gaoji-jiqiao'],
    content: [
      '麻将作为中国最受欢迎的棋牌游戏之一，有着悠久的历史和深厚的文化底蕴。对于新手来说，刚开始接触麻将可能会觉得规则复杂、牌型繁多。别担心，这份入门教程将带你从零开始，一步步学会打麻将。',
      '首先，让我们认识一下麻将的基本牌型。一副完整的麻将牌共有144张牌，分为五大类：万子牌（一万到九万，各4张，共36张）、条子牌（一条到九条，各4张，共36张）、筒子牌（一筒到九筒，各4张，共36张）、字牌（东南西北中发白，各4张，共28张）、花牌（春夏秋冬梅兰竹菊，各1张，共8张）。',
      '麻将的基本游戏规则：四名玩家各自摸13张牌（庄家14张），通过摸牌、出牌、吃碰杠等操作，将手中的牌组成特定的牌型后胡牌。胡牌的牌型必须满足"四组三张牌加一对将牌"的基本结构，即3+3+3+3+2的形式。',
      '吃牌：当上家打出你需要的牌时，你可以"吃"进这张牌，与手中的两张牌组成顺子。碰牌：当任何一家打出你手中已有两张的牌时，你可以"碰"进这张牌。杠牌：当你有三张相同的牌时，无论是自己摸到第四张还是别人打出第四张，都可以"杠"。',
      '听牌是麻将游戏的关键节点。当你距离胡牌只差一张牌时，就处于"听牌"状态。听牌时，你只需要等待合适的那张牌出现即可胡牌。听牌时机的把握非常重要——太早听牌牌型分值低，太晚听牌则可能被别人抢先胡牌。',
      '对于新手来说，建议从以下方面入手：先从单机模式练习，熟悉牌型和基本操作；学会识别基本的牌型组合；掌握吃碰杠的时机选择；培养观察对手出牌习惯的能力。记住，麻将是一项需要大量练习的游戏，不要因为初期的失败而气馁，每位麻将高手都经历过新手阶段。',
    ],
  },
  'guobiao-majiang-fanzhong': {
    tags: ['国标麻将', '番种详解', '进阶技巧'],
    relatedArticles: ['majiang-rumen-jiaocheng', 'majiang-gaoji-jiqiao'],
    content: [
      '国标麻将的81种番种是竞技麻将的核心体系，由国家体育总局于1998年正式颁布。这些番种按分值分为12个等级，从最低的1分到最高的88分，构成了国标麻将复杂的计分系统。',
      '1分番种是最基础的部分，包括：一般高（同花色、同序数的两副顺子）、喜相逢（两种花色、同序数的两副顺子）、连六（同花色、序数相连的六张牌）、老少副（同花色、以1和9为两端的顺子）等。这些基础番种虽然分值低，但在组合牌型中发挥着重要的基础作用。',
      '2分番种包含：平和（由四副顺子及序数牌作将组成的胡牌）、断幺（胡牌中没有幺九牌和字牌）、无字（没有字牌）、双暗刻（两个暗刻）等。这些番种的出现频率很高，是日常游戏中最常遇到的组合。',
      '88分的大番种是国标麻将中最令人兴奋的存在，包括：大四喜（由四副风刻组成的胡牌）、大三元（由中发白三副刻子组成的胡牌）、十三幺（由三种序数牌的1、9牌，七种字牌及其中一对作将组成的胡牌）、绿一色（由23468条及发字中任何牌组成的顺子、刻子、将牌）。这些大番种出现的概率极低，但一旦做成，将获得极高的分数。',
      '在实战中，合理的番种组合策略至关重要。建议优先确保达到8分的起和线，然后根据手牌情况灵活追求更高分值的番种。清一色(24分)是性价比较高的牌型方向，如果再配合平和(2分)、无字(1分)等，可以轻松达到30分以上。',
      '防守策略同样不可忽视。当你发现某位对手在做大牌时，要及时破坏对方的牌型。宁可放弃自己的小牌，也要阻止对手做大牌——这叫"防大不防小"原则。',
    ],
  },
  'sichuan-majiang-xuezhan': {
    tags: ['四川麻将', '血战到底', '玩法攻略'],
    relatedArticles: ['majiang-rumen-jiaocheng', 'xueliu-chenghe-jiqiao'],
    content: [
      '四川麻将，又称血战到底，是四川及重庆地区最流行的麻将玩法。它以108张牌（去除风牌和字牌）、必须缺一门以及血战到底规则为三大核心特色，在众多麻将流派中独树一帜。',
      '血战到底是四川麻将最引人入胜的规则：当有一家胡牌后，游戏并不结束，剩余三家继续摸牌打牌，直到只剩最后一家未胡牌为止。这意味着即使你最先胡牌，局势仍可能被后来居上的玩家改变。这种"胜者不能退场，败者仍有翻盘机会"的机制，让每局都充满了戏剧性。',
      '缺一门是四川麻将的另一个核心规则。每位玩家必须在万、条、筒三种花色中选择一门作为"缺门"，胡牌时手中不能含有该门花色的牌。这个规则大大简化了牌型组合的复杂度，同时增加了策略性——选择哪门作为缺门，直接影响你的牌型发展方向。',
      '四川麻将的杠牌规则也与众不同。明杠（别人打出的第四张牌）称为"刮风"，暗杠（自己摸到的第四张牌）称为"下雨"。杠牌后立即收取杠钱，且点杠者需要承担全部责任。因此杠牌的时机选择非常重要——贸然点杠不仅会消耗自己的牌，还可能帮对手做大牌。',
      '在四川麻将中，"清一色"是性价比最高的牌型。由于只有三种花色且必须缺一门，做清一色的难度大大降低。一旦做成清一色，可以获得原始番数的翻倍奖励，是快速拉开分差的有效手段。',
      '最后查叫是四川麻将的收尾环节。牌墙摸完后，所有未胡牌的玩家需要亮牌检查是否听牌。未听牌的玩家需要向已听牌的玩家支付查叫费。这个规则让"临门一脚"的听牌变得至关重要。',
    ],
  },
  'majiang-gaoji-jiqiao': {
    tags: ['高级技巧', '听牌策略', '防守反击'],
    relatedArticles: ['guobiao-majiang-fanzhong', 'majiang-xinli-zhan'],
    content: [
      '从新手到高手的进阶，不仅仅是牌技的提升，更是策略思维和心理博弈的升华。本文将分享资深玩家多年实战总结的经验和心得，帮助你从"会打麻将"进阶到"会赢麻将"。',
      '听牌策略是麻将中最核心的技巧之一。优秀的听牌策略需要考虑三个维度：听牌数量、牌型分值和安全性。听牌数量越多，胡牌概率越高；牌型分值决定了收益；而安全性则防止被对手猜到你的意图。最佳策略是在三者之间找到平衡。',
      '在牌局前期，建议走"宽路"——选择听牌数量多的方向发展。例如选择两面听（听两张牌）而非边张听（只听一张牌），可以将胡牌概率提高一倍。在牌局中后期，则需要根据牌墙剩余数量灵活调整策略。',
      '防守反击是麻将水平的分水岭。当自己牌运不佳时，不要强行进攻，而是转为防守。通过观察对手的出牌习惯，判断对方的牌型方向，然后"打对手不需要的牌"，让对手无法吃碰你的牌。同时暗中积累自己的牌型，等待反击时机。',
      '读牌能力是高手与普通玩家的最大区别。通过分析对手出牌的顺序、速度和选择，可以推断出对方大致的牌型。例如，如果对手在前几轮连续打出了一门花色的牌，很可能那门花色就是他的弃牌方向。善于读牌的玩家能在牌桌上占据信息优势。',
      '最后要记住，麻将是一项"七分牌运三分技术"的游戏。即使技术再好的玩家，也有牌运不佳的时候。保持平和的心态，在该进攻时果断出手，在该防守时耐心等待，才是长久之道。',
    ],
  },
  'majiang-xinli-zhan': {
    tags: ['心理战', '读牌', '对手分析'],
    relatedArticles: ['majiang-gaoji-jiqiao', 'guobiao-majiang-fanzhong'],
    content: [
      '麻将不仅是牌技的较量，更是一场心理博弈。当你坐在牌桌前，你面对的不是冰冷的麻将牌，而是三个有思想、有策略、会伪装的对手。掌握心理战的技巧，能让你的胜率大幅提升。',
      '读牌是心理战的第一步。每一个玩家都有独特的出牌习惯——有人喜欢打安全牌（跟打上家的牌），有人喜欢冒险（打生张），有人习惯快速出牌，有人则喜欢慢慢斟酌。观察并记录这些习惯，你能从中推测出对手的牌型和意图。',
      '拆牌分析是进阶技巧。当你看到对手打出了一张牌，要思考他为什么打这张牌而不是其他牌。如果对手突然停止打某一门花色的牌，很可能那门花色正要成顺子。如果对手久久不碰某张牌，很可能他手上的对子另有他用。',
      '伪装和迷惑是高级心理战术。故意打出某个花色的牌，让对方以为你在放弃那个花色的牌型，实际上你已经在做清一色。或者故意磨蹭一下出牌，让对方以为你在犹豫，实际上你早就想好了要打什么。这些技巧能有效干扰对方的判断。',
      '控制牌桌节奏也是心理战的一部分。当你牌运好时，可以适当放慢节奏，让对方陷入焦虑；当你牌运差时，加快节奏快速出牌，减少对手的思考时间。掌握节奏的人，就掌握了牌桌的主动权。',
      '最后，管理好自己的情绪至关重要。无论牌运好坏，都保持冷静和专注。不要因为一把好牌而得意忘形，也不要因为一把烂牌而自暴自弃。心理素质往往决定了最后的胜负。',
    ],
  },
  'xueliu-chenghe-jiqiao': {
    tags: ['血流成河', '连胡技巧', '玩法攻略'],
    relatedArticles: ['sichuan-majiang-xuezhan', 'majiang-gaoji-jiqiao'],
    content: [
      '血流成河是近年最火爆的麻将玩法之一。与传统的麻将规则不同，血流成河最大的特色是：胡牌后不下桌，继续摸牌打牌直到牌墙摸完。这意味着每局可能出现多次胡牌，最终的胜负由总分决定。',
      '了解血流成河的基本规则：四人参与，使用108张牌，必须缺一门。胡牌后，你可以继续摸牌、打牌、吃碰杠，也可以再次胡牌。当你自摸时，获得场上所有未胡牌玩家的积分；当别人点炮时，只从点炮者那里获得积分。',
      '连胡的核心策略：胡牌后不要放松警惕，剩余的机会仍有可能改变排名。如果你的分数领先，后续策略可以偏保守，多打安全牌；如果你的分数落后，就需要积极寻找高分的牌型组合，争取通过一次大胡逆转局势。',
      '缺门选择是血流成河的第一个重要决策。建议根据起手牌的花色分布来选择缺门——选择牌数最少的那门作为缺门。如果三门花色分布均匀，则根据首轮摸到的牌来灵活调整。',
      '血流成河的杠牌策略也需要注意。由于每局可以多次胡牌，杠牌带来的收益和风险都会被放大。暗杠相对安全，明杠则可能为对手创造机会。建议在确定自己牌型方向后再考虑杠牌，不要因为贪图杠钱而打乱自己的节奏。',
      '最后阶段（牌墙还剩10张以内）是血流成河最刺激的部分。此时所有玩家都接近听牌状态，每一轮出牌都可能触发胡牌。在这个阶段，优先考虑防守——宁愿放弃小胡的机会，也要避免点炮给对手。守住优势比追求更大的优势更重要。',
    ],
  },
};